import templateUrl from 'emun.on-demand/media/media-browser.htm'
import MediaBrowserController from 'emun.on-demand/media/media-browser.controller'

let MediaBrowserComponent = {
    bindings: {
        context: '@', //select,detail,applyToProducts,addToDesign
        title: '@',
        height: '@',
        append: '@',
        criteria: '<?',
        tagCriteria: '<?',
        onSelect: '&',
    },
    controller: MediaBrowserController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default MediaBrowserComponent;
